import { CommonModule } from '@angular/common';
import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { FormArray, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { TeacherOption } from 'src/app/services/models/subjects/subject.model';
import { SharedModule } from 'src/shared/shared.module';
import { LabelMode } from 'src/utils/label-mode.enum';

declare const bootstrap: any;

const STATIC_MODAL_OPTIONS = {
  backdrop: 'static',
  keyboard: false,
};

@Component({
  selector: 'app-project-teacher-modal',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    SharedModule,
  ],
  templateUrl: './project-teacher-modal.component.html',
  styleUrl: './project-teacher-modal.component.scss',
})
export class ProjectTeacherModalComponent {
  @Input({ required: true }) projectTeacherForm!: FormGroup;
  @Input({ required: true }) projectTeachingTimes!: FormArray<FormGroup>;
  @Input() teacherOptions: TeacherOption[] = [];
  @Input() teachingDayOptions: string[] = [];
  @Input() timeOptions: string[] = [];
  @Input() projectTeacherSubmitted = false;

  @Output() projectTeacherSelected = new EventEmitter<TeacherOption | undefined>();
  @Output() addTeachingTime = new EventEmitter<void>();
  @Output() removeTeachingTime = new EventEmitter<number>();
  @Output() teachingTimeChanged = new EventEmitter<void>();
  @Output() saveProjectTeacher = new EventEmitter<void>();
  @Output() cancelProjectTeacher = new EventEmitter<void>();

  @ViewChild('projectTeacherModal')
  private projectTeacherModal?: ElementRef<HTMLElement>;

  readonly LabelMode = LabelMode;

  open(): void {
    const modalEl = this.projectTeacherModal?.nativeElement;

    if (modalEl == null) {
      return;
    }

    bootstrap.Modal.getOrCreateInstance(modalEl, STATIC_MODAL_OPTIONS).show();
  }

  close(): void {
    const modalEl = this.projectTeacherModal?.nativeElement;

    if (modalEl == null) {
      return;
    }

    bootstrap.Modal.getInstance(modalEl)?.hide();
  }

  hasProjectTeacherError(controlName: string): boolean {
    const control = this.projectTeacherForm.get(controlName);

    return control != null && control.invalid && (this.projectTeacherSubmitted || control.touched);
  }

  hasProjectTeachingTimeError(time: FormGroup, controlName: string): boolean {
    const control = time.get(controlName);

    return control != null && control.invalid && (this.projectTeacherSubmitted || control.touched);
  }

  getProjectTeachingTimesError(): string {
    if (this.projectTeachingTimes.hasError('timeOrder')) {
      return 'เวลาเริ่มต้นต้องน้อยกว่าเวลาสิ้นสุด';
    }

    if (this.projectTeachingTimes.hasError('timeOverlap')) {
      return 'วันเดียวกันห้ามมีช่วงเวลาสอนซ้อนกัน';
    }

    return '';
  }
}
